import { render, staticRenderFns } from "./MsgElementPatient.vue?vue&type=template&id=d4f904ec&scoped=true"
import script from "./MsgElementPatient.vue?vue&type=script&lang=js"
export * from "./MsgElementPatient.vue?vue&type=script&lang=js"
import style0 from "./MsgElementPatient.vue?vue&type=style&index=0&id=d4f904ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f904ec",
  null
  
)

export default component.exports